import React from 'react';

const Card = ({ children, className = '', ...props }) => {
  return (
    <div className={`card ${className}`} {...props}>
      {children}
    </div>
  );
};

const CardHeader = ({ children, className = '' }) => {
  return (
    <div
      className={`text-base font-semibold pb-3 mb-1 ${className}`}
      style={{ color: 'var(--text-primary)', borderBottom: '1px solid var(--border-subtle)' }}
    >
      {children}
    </div>
  );
};

const CardBody = ({ children, className = '' }) => {
  return <div className={`pt-3 ${className}`}>{children}</div>;
};

const CardFooter = ({ children, className = '' }) => {
  return (
    <div
      className={`pt-4 mt-4 flex items-center gap-3 ${className}`}
      style={{ borderTop: '1px solid var(--border-subtle)' }}
    >
      {children}
    </div>
  );
};

Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;

export default Card;
